import { parsePhoneNumber, type PhoneNumberFormat } from 'awesome-phonenumber';

export { isValidEmail } from '@odo/shared-ui/utils/email';

const SUPPORTED_REGIONS = ['US', 'CA'] as const;

export const isValidPhone = (phone: string) => {
    const raw = (phone || '').trim();
    if (!raw) return false;
    const digits = raw.replace(/\D/g, '');
    return SUPPORTED_REGIONS.some((r) => parsePhoneNumber(digits, { regionCode: r }).valid);
};

export const formatPhone = (
    phone: string,
    region: string = 'US',
    mode: PhoneNumberFormat = 'national'
) => {
    const parsed = parsePhoneNumber(phone, { regionCode: region });
    if (!parsed.valid) return phone;
    switch (mode) {
        case 'e164':
            return parsed.number.e164;
        case 'international':
            return parsed.number.international;
        case 'rfc3966':
            return parsed.number.rfc3966;
        case 'significant':
            return parsed.number.significant;
        case 'national':
        default:
            return parsed.number.national;
    }
};
